import { imgHandler, textHandler } from './handler';
/*--------------------------------------------------代码--------------------------------------------------*/
function resolveExp(posVal, vars) {
    //@ts-ignore
    return new Function(...vars, `return (${posVal})`);
}
export async function calcLayout(layout, context) {
    layout = textHandler(layout);
    layout = await imgHandler(layout);
    if (!layout.padding) {
        layout.padding = [0, 0, 0, 0];
    }
    else if (typeof layout.padding === 'number') {
        layout.padding = [layout.padding, layout.padding, layout.padding, layout.padding];
    }
    let w = layout.width ? layout.width - layout.padding[1] - layout.padding[3] : undefined, h = layout.height ? layout.height - layout.padding[0] - layout.padding[2] : undefined;
    //vars和varsFix,varsList必须一一对应.
    let vars = [], values = [];
    layout.shapes.forEach((shape, index) => {
        if (!shape.id) {
            shape.id = '$' + index;
        }
        let pos = Object.assign({
            'top': `${shape.id}.bottom - ${shape.id}.height`,
            'bottom': `${shape.id}.top + ${shape.id}.height`,
            'left': `${shape.id}.right - ${shape.id}.width`,
            'right': `${shape.id}.left + ${shape.id}.width`,
            'width': `${shape.id}.right- ${shape.id}.left`,
            'height': `${shape.id}.bottom - ${shape.id}.top`
        }, shape.offset);
        //flag:防止循环引用.
        let flag = {
            width: false,
            height: false,
            left: false,
            top: false,
            bottom: false,
            right: false
        };
        let posProxy = new Proxy(pos, {
            get(tar, key) {
                let val = Reflect.get(tar, key);
                if (typeof val === 'number') {
                    return val;
                }
                else if (typeof val === 'string' || typeof val === 'function') {
                    if (!flag[key]) {
                        flag[key] = true;
                    }
                    else {
                        //已经循环引用
                        console.error('计算layout的pos时遇到循环引用:', tar);
                        throw new Error();
                    }
                    let calcVal, _vars = [...vars, 'w', 'h', 'self'], _values = [...values, w, h, tar], params = {};
                    if (shape.inject) {
                        for (let key in shape.inject) {
                            let injectFn = shape.inject[key];
                            if (typeof injectFn === 'function') {
                                _vars.push(key);
                                _values.push(injectFn(context, posProxy, shape));
                            }
                        }
                    }
                    _vars.forEach((varsVal, index) => {
                        params[varsVal] = _values[index];
                    });
                    if (typeof val === 'string') {
                        let fn = resolveExp(val, _vars);
                        calcVal = fn.call(shape, ..._values);
                    }
                    else {
                        let fn = val;
                        calcVal = fn(params);
                    }
                    Reflect.set(tar, key, calcVal);
                    return calcVal;
                }
                else {
                    console.error('pos的type不对:', shape);
                    throw new Error();
                }
            }
        });
        vars.push(shape.id);
        values.push(posProxy);
    });
    let posAbsoluteList = values.map(posProxy => {
        //触发所有getter
        let posGetter = { ...posProxy };
        return {
            left: posGetter.left,
            right: posGetter.right,
            top: posGetter.top,
            bottom: posGetter.bottom,
            width: posGetter.width,
            height: posGetter.height,
        };
    });
    layout.shapes.forEach((shape, index) => shape.offset = posAbsoluteList[index]);
    if (!layout.height) {
        layout.height = layout.shapes.reduce((prev, curShape) => {
            let bottom = curShape.offset.height + curShape.offset.top;
            return bottom > prev ? bottom : prev;
        }, 0);
        layout.height += layout.padding[0] + layout.padding[2];
    }
    if (!layout.width) {
        layout.width = layout.shapes.reduce((prev, curShape) => {
            let right = curShape.offset.width + curShape.offset.left;
            return right > prev ? right : prev;
        }, 0);
        layout.width += layout.padding[1] + layout.padding[3];
    }
    return layout;
}
